<script setup lang="ts">
import LGLogoLight from "~/components/logo/LGLogoLight.vue";
import type {NavigationMenuItem} from '@nuxt/ui'
import LGFooterContactSeperator from "~/components/footer/LGFooterContactSeperator.vue";
import LGFooterNewsletter from "~/components/footer/LGFooterNewsletter.vue";
import {useAuthStore} from "~~/stores/auth";

const auth = useAuthStore();

const {t, locale} = useI18n()
const localePath = useLocalePath()
const menuClasses = '!text-white uppercase opacity-60 hover:opacity-70 transition !text-[12px] lg:!text-[20px]';

const leftMenuItems = computed<NavigationMenuItem[][]>(() => {
    void locale.value

    return [[
        {label: t("footer.menuItems.shop"), to: localePath('vodici'), class: menuClasses},
        {label: t("footer.menuItems.ourStory"), to: localePath('moja-zgodba'), class: menuClasses},
    ]]
})

const rightMenuItems = computed<NavigationMenuItem[]>(() => {
    const items: NavigationMenuItem[] = [
        {label: t("footer.menuItems.forParents"), to: localePath('za-starse'), class: menuClasses},
    ]

    if (auth.user != null) {
        items.push({
                label: t("footer.menuItems.myGuides"),
                to: localePath('moj-racun-moji-vodici'),
                class: menuClasses
            },
        )
    } else {
        items.push({
                label: t("footer.menuItems.signIn"),
                to: localePath('moj-racun-prijava'),
                class: menuClasses
            },
        )
    }

    return items
})

</script>

<template>
    <UContainer class="px-0 sm:px-0 md:px-0 lg:px-8 -mt-50">
        <LGFooterNewsletter/>
    </UContainer>
    <UFooter class="z-1" role="contentinfo">
        <template #top>
            <UContainer>
                <div class="footer grid grid-cols-4 items-center lg:items-start gap-[10px] lg:gap-6 lg:pt-70">
                    <div class="col-span-1 pl-[5px]">
                        <LGLogoLight/>
                    </div>
                    <div class="col-span-4 lg:col-span-2">
                        <div class="footer-menu grid grid-cols-2">
                            <div class="col-span-1">
                                <UNavigationMenu
                                    :key="locale"
                                    orientation="vertical"
                                    variant="link"
                                    :items="leftMenuItems"
                                    class="w-full"
                                    role="navigation"
                                />
                            </div>
                            <div class="col-span-1">
                                <UNavigationMenu
                                    :key="locale + '-r'"
                                    orientation="vertical"
                                    variant="link"
                                    :items="rightMenuItems"
                                    class="w-full"
                                    role="navigation"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-span-5 lg:col-span-1 pt-6 lg:pt-0">
                        <div
                            class="flex flex-col justify-center items-center lg:bg-[url(/images/footer/footer-contact-bg.svg)] lg:bg-center lg:bg-contain lg:aspect-square lg:ml-auto lg:max-w-[270px] lg:-mt-12">
                            <LGFooterContactSeperator/>
                            <div
                                class="flex flex-row lg:flex-col lg:rotate-[6.5deg] items-center text-center font-bold gap-8 lg:gap-2">
                                <span class="block text-[20px] lg:text-[34px] text-[#F7948C] uppercase">{{
                                        t("footer.contact")
                                    }}</span>
                                <div>
                                    <ULink to="tel:0038640671185"
                                           class="block text-[16px] lg:text-[22px] text-[#F7948C] hover:text-[#F7948C]">
                                        +386 40 671 185
                                    </ULink>
                                    <ULink to="mailto:hello@lyraguides.com"
                                           class="block text-[16px] lg:text-[18px] text-[#F7948C] hover:text-[#F7948C]">
                                        hello@lyraguides.com
                                    </ULink>
                                </div>
                            </div>
                            <LGFooterContactSeperator/>
                        </div>
                    </div>
                </div>
            </UContainer>
        </template>

        <template #bottom>
            <UContainer>
                <USeparator type="solid" class="py-6 opacity-60 hidden lg:flex"/>
                <div class="absolute-footer flex flex-col lg:flex-row items-center justify-between gap-4.5">
                    <div class="flex flex-col lg:flex-row items-center lg:items-top gap-1.5 lg:gap-5.5">
                        <ULink :to="localePath('splosni-pogoji-poslovanja')"
                               class="uppercase font-medium text-[12px] lg:text-[18px] text-white opacity-60 hover:opacity-70 hover:text-white transition">
                            {{ t("footer.termsAndConditions") }}
                        </ULink>
                        <ULink :to="localePath('politika-zasebnosti-in-piskotkov')"
                               class="uppercase font-medium text-[12px] lg:text-[18px] text-white opacity-60 hover:opacity-70 hover:text-white transition">
                            {{ t("footer.privacyPolicy") }}
                        </ULink>
                    </div>
                    <div>
                        <span class="font-medium text-[12px] lg:text-[18px] text-white opacity-60">Copyright © {{
                                new Date().getFullYear()
                            }} |</span>
                        <ULink to="https://flick-web.com" target="_blank"
                               class="font-medium text-[12px] lg:text-[18px] text-white opacity-60 hover:opacity-70 hover:text-white transition">
                            FlickWeb
                        </ULink>
                    </div>
                </div>
            </UContainer>
        </template>

    </UFooter>
</template>

<style scoped>
.footer *, .absolute-footer * {
    font-family: "Quicksand", sans-serif !important;
}
</style>
